var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDice = function SvgDice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.772 15.168H6.574a2.8 2.8 0 0 0-2.8 2.8v11.197a2.8 2.8 0 0 0 2.8 2.8h11.198a2.8 2.8 0 0 0 2.8-2.8V17.967a2.8 2.8 0 0 0-2.8-2.799ZM26.06 20.766l4.898-4.899a3.136 3.136 0 0 0 0-4.199L23.96 4.781a3.136 3.136 0 0 0-4.2 0L14.973 9.57M9.374 26.365h.015M14.973 20.766h.015M21.972 9.568h.014M26.171 13.768h.015",
    stroke: "#fff",
    strokeWidth: 2.799,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgDice;